import img_source from "../../../assets/images/callout/callout.webp";

export const Categories = {
  "Community": {
    "Image": img_source,
    "Alt": "Alt text",
    "Link": "https://slack.layer5.io"
  }
};